(() => {
  function listenForClicks(e) {
    e.addEventListener("click", function(e) {
      let el = e.currentTarget;
      if (el != e.target && el != e.target.parentElement) return; // do nothing if a grandchild element is clicked (needed for nav)
      let newClass = el.getAttribute("class").split("js-tglslf-")[1].split(" ")[0];
      el.classList.toggle(newClass);
    })
  }
  document.querySelectorAll("[class*='js-tglslf-']").forEach(function(e) {
    listenForClicks(e)
  });
})();
